<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      label-position="right"
      label-width="160px"
      class="demo-ruleForm leftpad"
      v-model="examHyperq"
      :rules="rules"
    >
      <el-form-item label="建议运动方案：">
        <el-input placeholder="建议运动方案 功能暂无 " disabled></el-input>
      </el-form-item>
      <el-form-item label="实际运动方案：">
        <el-input v-model="examHyperq.protocol" :disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="运动负荷起点：">
        <el-input
          v-model="examHyperq.beginLoad"
          type="number"
          :disabled="disabled"
        ></el-input>
      </el-form-item>
      <el-form-item label="目标心率：" size="mini" prop="targetHr">
        <el-input v-model="examHyperq.targetHr" :disabled="disabled">
          <template slot="append">次/分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="达到目标心率时间：" size="mini">
        <el-input v-model="examHyperq.reachTargetHrTime" :disabled="disabled">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="实际达到心率：" size="mini">
        <el-input v-model="examHyperq.actualHr" :disabled="disabled">
          <template slot="append">次/分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="实际达到心率时间：" size="mini">
        <el-input v-model="examHyperq.reachActualHrTime" :disabled="disabled">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="运动最大负荷：">
        <el-input v-model="examHyperq.maxLoad" type="number" :disabled="disabled">
          <template slot="append">瓦</template>
        </el-input>
      </el-form-item>
      <el-form-item label="达到运动最大负荷时间：">
        <el-input
          v-model="examHyperq.maxLoadTime"
          type="number"
          :disabled="disabled"
        >
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>

      <el-form-item label="运动结束时间：" size="mini">
        <el-input v-model="examHyperq.execiseEndTime" :disabled="disabled">
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>

      <el-form-item label="峰值后恢复心率：" size="mini">
        <el-input
          v-model="examHyperq.recoverTimeAfterPeakHr"
          :disabled="disabled"
        >
          <template slot="append">次/分钟</template>
        </el-input>
      </el-form-item>


      <el-form-item label="峰值后心率恢复时间：">
        <el-input
          v-model="examHyperq.maxHeartRecoverTime"
          type="number"
          :disabled="disabled"
        >
          <template slot="append">分钟</template>
        </el-input>
      </el-form-item>
      <el-form-item label="运动血压：">
        <el-input v-model="examHyperq.exerciseBloodPressure" :disabled="disabled">
          <template slot="append">mmHg</template>
        </el-input>
      </el-form-item>
      <el-form-item label="代谢当量：">
        <el-input v-model="examHyperq.met" type="number" :disabled="disabled">
          <template slot="append">MET</template>
        </el-input>
      </el-form-item>
      <el-form-item label="最大代谢量：">
        <el-input
          v-model="examHyperq.maxMet"
          type="number"
          :disabled="disabled"
        ></el-input>
      </el-form-item>

      <el-form-item label="心肌细胞缺血风险等级:" size="mini">
        <el-radio-group v-model="examHyperq.miGrade" :disabled="disabled">
          <el-radio label="low">低风险</el-radio>
          <el-radio label="hint">提示有风险</el-radio>
          <el-radio label="middle">中度风险</el-radio>
          <el-radio label="high">高风险</el-radio>
          <el-radio label="extreme">极高风险</el-radio>
          <el-radio label="other">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="心肌细胞缺血类型:" size="mini">
        <el-radio-group v-model="examHyperq.miType" :disabled="disabled">
          <el-radio label="organic">器质性</el-radio>
          <el-radio label="function">功能性</el-radio>
          <el-radio label="hybrid">混合型</el-radio>
          <el-radio label="endurance">心脏耐力下降</el-radio>
          <el-radio label="elasticity">心脏血管弹性降低</el-radio>
          <el-radio label="others">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="血管堵塞程度（估算）:" size="mini">
        <el-progress
          type="line"
          :stroke-width="15"
        :percentage="examHyperq.percentageOfMi"
        :color="examHyperq.percentageOfMi < 25 ? blue : (examHyperq.percentageOfMi < 50 ? yellow : (examHyperq.percentageOfMi < 75 ? red : brown))"
        :format="format"
        >
        </el-progress>
      </el-form-item>

      <el-form-item label="冠脉狭窄诊断结果:" size="mini">
        {{ examHyperq.diagnosis }}
      </el-form-item>

      <el-form-item label="BSP 文件:" size="mini">
        <div v-if="examHyperq.bspFile !== ''">
          <el-row class="el-row" type="flex">
            <a style="width: 100%" :href="examHyperq.bspFile" :disabled="ecgDisabled" v-if="examHyperq.bspFile" target="_blank">
              {{ examHyperq.bspFile }}
            </a>
          </el-row>

        </div>
        <el-upload
          class="upload-demo"
          :action="upload4Cospath('bsp')"
          :on-preview="handlePreview"
          accept="*"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-success="(value)=> uploadPdfSuccess('bspFile', value)"
          :limit="1"
          :on-exceed="handleExceed"
          :auto-upload="true"
          :file-list="fileList">
          <el-button style="margin:0px 0px 0px 12px;" size="mini" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>

    <el-form-item label="运动HyperQ检测报告" size="mini">
      <div v-if="examHyperq.hyperqFile !== ''">
        <el-row class="el-row" type="flex">
          <a style="width: 100%" :href="examHyperq.hyperqFile" :disabled="ecgDisabled" v-if="examHyperq.hyperqFile" target="_blank">
            {{ examHyperq.hyperqFile }}
          </a>
          <el-button type="primary" v-if="examHyperq.hyperqFile" class="button-color" @click="showPdf($event,'hyperqRef')">展开</el-button>
        </el-row>
        <div >
          <embed ref="hyperqRef" :src="examHyperq.hyperqFile" width="100%" height="600px" style="display:none"/>
        </div>
      </div>
      <el-upload
        class="upload-demo"
        :action="upload4Cospath('pdf')"
        :on-preview="handlePreview"
        accept="application/pdf"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-success="(value)=> uploadPdfSuccess('hyperqPdf', value)"
        :limit="1"
        :on-exceed="handleExceed"
        :auto-upload="true"
        :file-list="fileList">
        <el-button style="margin:0px 0px 0px 12px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </el-form-item>

    </el-form>

    <el-form :disabled="disabled">
      <!-- HyperQ 自定义结构表格 -表头 -->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">\&nbsp;</el-col>
            <el-col :span="12">总数</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2"> I </el-col>
            <el-col :span="2"> II </el-col>
            <el-col :span="2"> III </el-col>
            <el-col :span="2"> aVR </el-col>
            <el-col :span="2"> aVL </el-col>
            <el-col :span="2"> aVF </el-col>
            <el-col :span="2"> V1 </el-col>
            <el-col :span="2"> V2 </el-col>
            <el-col :span="2"> v3 </el-col>
            <el-col :span="2"> v4 </el-col>
            <el-col :span="2"> v5 </el-col>
            <el-col :span="2"> v6 </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- HyperQ 自定义结构表格 -第一行 阳性-->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">阳性</el-col>
            <el-col :span="12">{{ examHyperq.totalPositive }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.ipositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iiPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iiiPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avrPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avlPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avfPositive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v1Positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v2Positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v3Positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v4Positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v5Positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v6Positive"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- HyperQ 自定义结构表格 -第二行 临界-->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">临界</el-col>
            <el-col :span="12">{{ examHyperq.totalBorderline }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iborderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iiBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iiiBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avrBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avlBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avfBorderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v1Borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v2Borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v3Borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v4Borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v5Borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v6Borderline"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
          </el-row> </el-col
      ></el-row>

      <!-- HyperQ 自定义结构表格 -第三行 异常-->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">异常</el-col>
            <el-col :span="12">{{ examHyperq.totalException }}</el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iexception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iiException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.iiiException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avrException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avlException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.avfException"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v1Exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v2Exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v3Exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v4Exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v5Exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
            <el-col :span="2">
              <el-switch
                v-model="examHyperq.v6Exception"
                :active-text="HyperQp"
                :inactive-text="HyperQn"
              >
              </el-switch>
            </el-col>
          </el-row> </el-col
      ></el-row>

      <!-- HyperQ 自定义结构表格 -第四行-电压 -->
      <el-row class="alignCenter">
        <el-col :span="3">
          <el-row>
            <el-col :span="12">波形</el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.iWaveType!='others'}">{{ examHyperq.iWaveType }}</span>
              <el-select v-model="examHyperq.iWaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.iiWaveType!='others'}">{{ examHyperq.iiWaveType }}</span>
              <el-select v-model="examHyperq.iiWaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.iiiWaveType!='others'}">{{ examHyperq.iiiWaveType }}</span>
              <el-select v-model="examHyperq.iiiWaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.avrWaveType!='others'}">{{ examHyperq.avrWaveType }}</span>
              <!-- {{ examHyperq.avrWaveType }} -->
              <el-select v-model="examHyperq.avrWaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.avlWaveType!='others'}">{{ examHyperq.avlWaveType }}</span>
              <!-- {{ examHyperq.avlWaveType }} -->
              <el-select v-model="examHyperq.avlWaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.avfWaveType!='others'}">{{ examHyperq.avfWaveType }}</span>
              <!-- {{ examHyperq.avfWaveType }} -->
              <el-select v-model="examHyperq.avfWaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.v1WaveType!='others'}">{{ examHyperq.v1WaveType }}</span>
              <!-- {{ examHyperq.v1WaveType }} -->
              <el-select v-model="examHyperq.v1WaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.v2WaveType!='others'}">{{ examHyperq.v2WaveType }}</span>
              <!-- {{ examHyperq.v2WaveType }} -->
              <el-select v-model="examHyperq.v2WaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.v3WaveType!='others'}">{{ examHyperq.v3WaveType }}</span>
              <!-- {{ examHyperq.v3WaveType }} -->
              <el-select v-model="examHyperq.v3WaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.v4WaveType!='others'}">{{ examHyperq.v4WaveType }}</span>
              <!-- {{ examHyperq.v4WaveType }} -->
              <el-select v-model="examHyperq.v4WaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.v5WaveType!='others'}">{{ examHyperq.v5WaveType }}</span>
              <!-- {{ examHyperq.v5WaveType }} -->
              <el-select v-model="examHyperq.v5WaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <span :class="{redStr: examHyperq.v6WaveType!='others'}">{{ examHyperq.v6WaveType }}</span>
              <!-- {{ examHyperq.v6WaveType }} -->
              <el-select v-model="examHyperq.v6WaveType" placeholder=".">
                <el-option
                  v-for="item in waveOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="30" style="margin-top: 20px">
      <el-col :span="24" class="alignCenter">
        <el-button
          :loading="submitting"
          type="primary"
          size="medium"
          @click="_updateExamHyperq"
          class="fullWidth"
          v-show="!disabled"
          :disabled="examHyperq.targetHr === ''"
          >保存</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import {
  getExamHyperq,
  updateExamHyperq,
  updateExamState,
  uploadFile,
  download,
} from "../../api/userExamService";
import { baseURL } from "../../api/axiosCreator";
import { waveOptions } from "../../utils/constants";
export default {
  name: "HyperQExam",
  props: {
    examUuid: String,
    disabled: Boolean,
    hyperqDisabled: Boolean,
  },
  data() {
    return {
      fileList: [],
      hyperQShow: false,
      ecgDisabled: false,
      submitting: false,
      upload_pdf_file: "",
      upload_bsp_file: "",
      hyperQFileUrl: "",
      bspFileUrl: "",
      dialogVisible: false,
      restHyperQShow: false,
      //HyperQ检查
      examHyperq: {
        maxHr: "",
        met: "",
        beginLoad: "",
        exerciseBloodPressure: "",
        protocol: "",
        maxLoad: "",
        maxLoadTime: "",
        maxHeartRecover: "",
        maxHeartRecoverTime: "",
        maxMet: "",
        ////////////////
        actualHr: "",
        reachActualHrTime: "",
        targetHr: "",
        reachTargetHrTime: "",
        recoverTimeAfterPeakHr: "",
        execiseEndTime: "",
        avfBorderline: false,
        avfException: false,
        avfPositive: false,
        avfWaveType: "",
        avlBorderline: false,
        avlException: false,
        avlPositive: false,
        avlWaveType: "",
        avrBorderline: false,
        avrException: false,
        avrPositive: false,
        avrWaveType: "",
        examUuid: "",
        hyperqFile: "",
        rawStressFile: "",
        restHyperqFile: "",
        bspFile: "",
        iWaveType: "",
        iborderline: false,
        iexception: false,
        iiBorderline: false,
        iiException: false,
        iiPositive: false,
        iiWaveType: "",
        iiiBorderline: false,
        iiiException: false,
        iiiPositive: false,
        iiiWaveType: "",
        ipositive: false,
        miGrade: "",
        miType: "",
        totalBorderline: 0,
        totalException: 0,
        totalPositive: 0,
        v1Borderline: false,
        v1Exception: false,
        v1Positive: false,
        v1WaveType: "",
        v2Borderline: false,
        v2Exception: false,
        v2Positive: false,
        v2WaveType: "",
        v3Borderline: false,
        v3Exception: false,
        v3Positive: false,
        v3WaveType: "",
        v4Borderline: false,
        v4Exception: false,
        v4Positive: false,
        v4WaveType: "",
        v5Borderline: false,
        v5Exception: false,
        v5Positive: false,
        v5WaveType: "",
        v6Borderline: false,
        v6Exception: false,
        v6Positive: false,
        v6WaveType: "",
        diagnosis: "",
        percentageOfMi:""
      },
      HyperQp: "",
      HyperQn: "",
      //波形选项
      waveOptions: waveOptions,
      initialized: false,
      rules: {
        targetHr: [
          { required: true, message: "请输入实际最大心率", trigger: "blur" },
          { min: 2, max: 3, message: "长度在 1 到 3 个数字", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    examHyperq: {
      handler: function () {
        // console.log(val)
      },
      deep: true,
    },
    "examHyperq.ipositive": function (val) {
      if (val) {
        this.examHyperq.iborderline = false;
        this.examHyperq.iexception = false;
      }
    },
    "examHyperq.iborderline": function (val) {
      if (val) {
        this.examHyperq.ipositive = false;
        this.examHyperq.iexception = false;
      }
    },
    "examHyperq.iexception": function (val) {
      if (val) {
        this.examHyperq.ipositive = false;
        this.examHyperq.iborderline = false;
        // this.examHyperq.iexception = false
      }
    },
    //ii
    "examHyperq.iiPositive": function (val) {
      if (val) {
        this.examHyperq.iiBorderline = false;
        this.examHyperq.iiException = false;
      }
    },
    "examHyperq.iiBorderline": function (val) {
      if (val) {
        this.examHyperq.iiPositive = false;
        this.examHyperq.iiException = false;
      }
    },
    "examHyperq.iiException": function (val) {
      if (val) {
        this.examHyperq.iiPositive = false;
        this.examHyperq.iiBorderline = false;
      }
    },
    //iii
    "examHyperq.iiiPositive": function (val) {
      if (val) {
        this.examHyperq.iiiBorderline = false;
        this.examHyperq.iiiException = false;
      }
    },
    "examHyperq.iiiBorderline": function (val) {
      if (val) {
        this.examHyperq.iiiPositive = false;
        this.examHyperq.iiiException = false;
      }
    },
    "examHyperq.iiiException": function (val) {
      if (val) {
        this.examHyperq.iiiPositive = false;
        this.examHyperq.iiiBorderline = false;
      }
    },
    //avr
    "examHyperq.avrPositive": function (val) {
      if (val) {
        this.examHyperq.avrBorderline = false;
        this.examHyperq.avrException = false;
      }
    },
    "examHyperq.avrBorderline": function (val) {
      if (val) {
        this.examHyperq.avrPositive = false;
        this.examHyperq.avrException = false;
      }
    },
    "examHyperq.avrException": function (val) {
      if (val) {
        this.examHyperq.avrPositive = false;
        this.examHyperq.avrBorderline = false;
      }
    },
    //avl
    "examHyperq.avlPositive": function (val) {
      if (val) {
        this.examHyperq.avlBorderline = false;
        this.examHyperq.avlException = false;
      }
    },
    "examHyperq.avlBorderline": function (val) {
      if (val) {
        this.examHyperq.avlPositive = false;
        this.examHyperq.avlException = false;
      }
    },
    "examHyperq.avlException": function (val) {
      if (val) {
        this.examHyperq.avlPositive = false;
        this.examHyperq.avlBorderline = false;
      }
    },
    //avf
    "examHyperq.avfPositive": function (val) {
      if (val) {
        this.examHyperq.avfBorderline = false;
        this.examHyperq.avfException = false;
      }
    },
    "examHyperq.avfBorderline": function (val) {
      if (val) {
        this.examHyperq.avfPositive = false;
        this.examHyperq.avfException = false;
      }
    },
    "examHyperq.avfException": function (val) {
      if (val) {
        this.examHyperq.avfPositive = false;
        this.examHyperq.avfBorderline = false;
      }
    },
    //v1
    "examHyperq.v1Positive": function (val) {
      if (val) {
        this.examHyperq.v1Borderline = false;
        this.examHyperq.v1Exception = false;
      }
    },
    "examHyperq.v1Borderline": function (val) {
      if (val) {
        this.examHyperq.v1Positive = false;
        this.examHyperq.v1Exception = false;
      }
    },
    "examHyperq.v1Exception": function (val) {
      if (val) {
        this.examHyperq.v1Positive = false;
        this.examHyperq.v1Borderline = false;
      }
    },
    //v2
    "examHyperq.v2Positive": function (val) {
      if (val) {
        this.examHyperq.v2Borderline = false;
        this.examHyperq.v2Exception = false;
      }
    },
    "examHyperq.v2Borderline": function (val) {
      if (val) {
        this.examHyperq.v2Positive = false;
        this.examHyperq.v2Exception = false;
      }
    },
    "examHyperq.v2Exception": function (val) {
      if (val) {
        this.examHyperq.v2Positive = false;
        this.examHyperq.v2Borderline = false;
      }
    },
    //v3
    "examHyperq.v3Positive": function (val) {
      if (val) {
        this.examHyperq.v3Borderline = false;
        this.examHyperq.v3Exception = false;
      }
    },
    "examHyperq.v3Borderline": function (val) {
      if (val) {
        this.examHyperq.v3Positive = false;
        this.examHyperq.v3Exception = false;
      }
    },
    "examHyperq.v3Exception": function (val) {
      if (val) {
        this.examHyperq.v3Positive = false;
        this.examHyperq.v3Borderline = false;
      }
    },
    //v4
    "examHyperq.v4Positive": function (val) {
      if (val) {
        this.examHyperq.v4Borderline = false;
        this.examHyperq.v4Exception = false;
      }
    },
    "examHyperq.v4Borderline": function (val) {
      if (val) {
        this.examHyperq.v4Positive = false;
        this.examHyperq.v4Exception = false;
      }
    },
    "examHyperq.v4Exception": function (val) {
      if (val) {
        this.examHyperq.v4Positive = false;
        this.examHyperq.v4Borderline = false;
      }
    },
    //v5
    "examHyperq.v5Positive": function (val) {
      if (val) {
        this.examHyperq.v5Borderline = false;
        this.examHyperq.v5Exception = false;
      }
    },
    "examHyperq.v5Borderline": function (val) {
      if (val) {
        this.examHyperq.v5Positive = false;
        this.examHyperq.v5Exception = false;
      }
    },
    "examHyperq.v5Exception": function (val) {
      if (val) {
        this.examHyperq.v5Positive = false;
        this.examHyperq.v5Borderline = false;
      }
    },
    //v6
    "examHyperq.v6Positive": function (val) {
      if (val) {
        this.examHyperq.v6Borderline = false;
        this.examHyperq.v6Exception = false;
      }
    },
    "examHyperq.v6Borderline": function (val) {
      if (val) {
        this.examHyperq.v6Positive = false;
        this.examHyperq.v6Exception = false;
      }
    },
    "examHyperq.v6Exception": function (val) {
      if (val) {
        this.examHyperq.v6Positive = false;
        this.examHyperq.v6Borderline = false;
      }
    },
  },
  methods: {
    showPdf(e, ref){
				let isHidden = this.$refs[ref].style.display == "none";
        if(isHidden) {
          this.$refs[ref].style.display = "block";
          e.currentTarget.textContent = "折叠";
        }else {
          this.$refs[ref].style.display = "none";
          e.currentTarget.textContent = "展开";
        }
		},
    tirggerFile(e) {
      var patter = /^.*_bsp$|^.*pdf$|^.*PDF$/;
      var isFileSuffixMatchered = patter.test(e);
      if (!isFileSuffixMatchered) {
        this.dialogVisible = true;
      }
      console.log(e);
    },
    //根据examUuid获取HyperQ检查数据
    _getExamHyperq() {
      let self = this;
      getExamHyperq(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            // this.initialized = false;
            self.examHyperq.maxHr=res.data[0].maxHr;
            self.examHyperq.met=res.data[0].met;
            self.examHyperq.beginLoad=res.data[0].beginLoad;
            self.examHyperq.exerciseBloodPressure=res.data[0].exerciseBloodPressure;
            self.examHyperq.protocol=res.data[0].protocol;
            self.examHyperq.maxLoad=res.data[0].maxLoad;
            self.examHyperq.maxLoadTime=res.data[0].maxLoadTime;
            self.examHyperq.maxHeartRecover=res.data[0].maxHeartRecover;
            self.examHyperq.maxHeartRecoverTime=res.data[0].maxHeartRecoverTime;
            self.examHyperq.maxMet=res.data[0].maxMet;
            ///////////////
            self.examHyperq.actualHr = res.data[0].actualHr;
            self.examHyperq.reachActualHrTime = res.data[0].reachActualHrTime;
            self.examHyperq.reachActualHrTime = res.data[0].reachActualHrTime;
            self.examHyperq.targetHr = res.data[0].targetHr;
            self.examHyperq.reachTargetHrTime = res.data[0].reachTargetHrTime;
            self.examHyperq.recoverTimeAfterPeakHr =
              res.data[0].recoverTimeAfterPeakHr;
            self.examHyperq.execiseEndTime = res.data[0].execiseEndTime;
            self.examHyperq.avfBorderline = res.data[0].avfBorderline;
            self.examHyperq.avfException = res.data[0].avfException;
            self.examHyperq.avfPositive = res.data[0].avfPositive;
            self.examHyperq.avfWaveType = res.data[0].avfWaveType;
            self.examHyperq.avlBorderline = res.data[0].avlBorderline;
            self.examHyperq.avlException = res.data[0].avlException;
            self.examHyperq.avlPositive = res.data[0].avlPositive;
            self.examHyperq.avlWaveType = res.data[0].avlWaveType;
            self.examHyperq.avrBorderline = res.data[0].avrBorderline;
            self.examHyperq.avrException = res.data[0].avrException;
            self.examHyperq.avrPositive = res.data[0].avrPositive;
            self.examHyperq.avrWaveType = res.data[0].avrWaveType;
            self.examHyperq.examUuid = res.data[0].examUuid;
            self.examHyperq.hyperqFile = res.data[0].hyperqFile;
            self.examHyperq.restHyperqFile = res.data[0].restHyperqFile;
            self.examHyperq.bspFile = res.data[0].bspFile;
            self.examHyperq.iWaveType = res.data[0].iWaveType;
            self.examHyperq.iborderline = res.data[0].iborderline;
            self.examHyperq.iexception = res.data[0].iexception;
            self.examHyperq.iiBorderline = res.data[0].iiBorderline;
            self.examHyperq.iiException = res.data[0].iiException;
            self.examHyperq.iiPositive = res.data[0].iiPositive;
            self.examHyperq.iiWaveType = res.data[0].iiWaveType;
            self.examHyperq.iiiBorderline = res.data[0].iiiBorderline;
            self.examHyperq.iiiException = res.data[0].iiiException;
            self.examHyperq.iiiPositive = res.data[0].iiiPositive;
            self.examHyperq.iiiWaveType = res.data[0].iiiWaveType;
            self.examHyperq.ipositive = res.data[0].ipositive;
            self.examHyperq.miGrade = res.data[0].miGrade;
            self.examHyperq.miType = res.data[0].miType;
            self.examHyperq.totalBorderline = res.data[0].totalBorderline;
            self.examHyperq.totalException = res.data[0].totalException;
            self.examHyperq.totalPositive = res.data[0].totalPositive;
            self.examHyperq.v1Borderline = res.data[0].v1Borderline;
            self.examHyperq.v1Exception = res.data[0].v1Exception;
            self.examHyperq.v1Positive = res.data[0].v1Positive;
            self.examHyperq.v1WaveType = res.data[0].v1WaveType;
            self.examHyperq.v2Borderline = res.data[0].v2Borderline;
            self.examHyperq.v2Exception = res.data[0].v2Exception;
            self.examHyperq.v2Positive = res.data[0].v2Positive;
            self.examHyperq.v2WaveType = res.data[0].v2WaveType;
            self.examHyperq.v3Borderline = res.data[0].v3Borderline;
            self.examHyperq.v3Exception = res.data[0].v3Exception;
            self.examHyperq.v3Positive = res.data[0].v3Positive;
            self.examHyperq.v3WaveType = res.data[0].v3WaveType;
            self.examHyperq.v4Borderline = res.data[0].v4Borderline;
            self.examHyperq.v4Exception = res.data[0].v4Exception;
            self.examHyperq.v4Positive = res.data[0].v4Positive;
            self.examHyperq.v4WaveType = res.data[0].v4WaveType;
            self.examHyperq.v5Borderline = res.data[0].v5Borderline;
            self.examHyperq.v5Exception = res.data[0].v5Exception;
            self.examHyperq.v5Positive = res.data[0].v5Positive;
            self.examHyperq.v5WaveType = res.data[0].v5WaveType;
            self.examHyperq.v6Borderline = res.data[0].v6Borderline;
            self.examHyperq.v6Exception = res.data[0].v6Exception;
            self.examHyperq.v6Positive = res.data[0].v6Positive;
            self.examHyperq.v6WaveType = res.data[0].v6WaveType;
            self.examHyperq.percentageOfMi = res.data[0].percentageOfMi;
            self.examHyperq.diagnosis = res.data[0].diagnosis;
            self.initialized = true;
            // this.examHyperq = res.data[0];
          }
        } else {
          this.$message({
            message: res.description,
            type: "warning",
          });
        }
      });
    },
    //更新HyperQ检查
    _updateExamHyperq() {
      this.submitting = true;
      updateExamHyperq(this.examHyperq)
        .then((res) => {
          this.submitting = false;
          if (res.success) {
            this.$message({ message: res.description, type: "success" });
            //更新检查状态后，重新获取检查信息
            this._updateExamState(
              ExamStatesValue.HYPERQ_70,
              this._getExamHyperq
            );
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        })
        .catch((e) => {
          this.submitting = false;
          console.log(e);
        });
    },

    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    _uploadFile(id, type) {
      let file = document.querySelector("#fileinput_" + id).files[0];
      let fileNameMatchesType = this.isCorrectFileType(file.name, type);
      //判断文件类是是否为pdf
      if (!fileNameMatchesType) {
        this.$message({
          message: "请上传" + type + "格式的文件",
          type: "warning",
        });
        return;
      }

      let formData = new FormData();
      formData.append("file", file);

      let dataType = "none";
      if (id == "2") {
        dataType="HyperQStress";
      }else if (id == "3") {
        dataType="HyperQRest";
      }

      //路径参数 "examUuid/fileType"
      let params = this.examUuid + "/" + type + "/" + dataType;
      uploadFile(params, formData)
        .then((res) => {
          if (res.success) {
            if (res.data[0]) {
              if (type.match("pdf")) {
                this.examHyperq.hyperqFile = res.data[0];
              } else {
                this.examHyperq.bspFile = res.data[0];
                this._updateExamHyperq();
              }
            }
            this.$message({ message: res.description, type: "success" });
          } else {
            this.$message({ message: res.description, type: "warning" });
          }
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
        });
    },
    isCorrectFileType(fileName, type) {
      return fileName.match(type);
    },
    
    submitUploadRest() {
      this.$refs.uploadRest.submit();
    },
    submitUploadStress() {
      this.$refs.uploadStress.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    uploadSuccess(res) {
      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        this.fileList.pop();
      } else {
        this.$message.error("上传失败，请重新上传");
      }
    },
    format(percentage) {
      if (percentage < 25) {
        return "0~25%";
      } else if (percentage < 50) {
        return "25~50%";
      }else if (percentage < 75) {
        return "50~75%";
      } else {
        return "75~100%";
      }
    },
    getColor() {
        return this.examHyperq.percentageOfMi < 25 ? "blue" : (this.examHyperq.percentageOfMi < 50 ? "yellow" : (this.examHyperq.percentageOfMi < 75 ? "red" : "brown"));
    },
    uploadPdfSuccess(ref,res) {
      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        let url = res.data[0];
        if(ref=='bspFile') {
          this.examHyperq.bspFile = url;
        } else if (ref=='hyperqPdf') {
          this.examHyperq.hyperqFile = url;
        }
        this.fileList.pop();
      } else {
        this.$message.error("上传失败，请重新上传");
      }
      return;
    },

    uploadError() {
      this.$refs.upload.clearFiles();
      this.$message.error("上传失败，请重新上传");
    }
  
  },


  computed: {
    uploadPath() {
      return (isRest) => {
        return ( baseURL + "/ExamService/uploadFile/" + this.examUuid +"/zip/" + isRest);
      };
    },
    upload4Cospath() {
      return (type) => {
        return (baseURL + "/ExamService/uploadFile4Cos/" + this.examUuid + "/" +type + "/" + true);
      };
    }
  },

  created() {
    this.examHyperq.examUuid = this.examUuid;
    this.hyperQFileUrl = download(this.examUuid + "/pdf");
    this.bspFileUrl = download(this.examUuid + "/bsp");
    this._getExamHyperq();
  },

  mounted() {
    this.$EventBus.$on("ecgFileUploaded", () => {
      this._getExamHyperq();
      //this.$message.error("updated");
    });
 }
};
</script>

<style scoped lang=less>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.no-margin {
  margin-bottom: 0;
}
/* .el-row:last-child {
  margin-bottom: 0;
} */

.el-col {
  border-radius: 4px;
}

.shortInput {
  width: 40px;
}

.mediumInput {
  width: 80px;
}

.longInput {
  width: 200px;
}

.leftpad {
  padding-left: 30px;
}

.alignCenter {
  text-align: center;
}
.alignRight {
  text-align: right;
}
.fullWidth {
  width: 100%;
}

.redStr{
  color: red;
}
</style>